import * as React from "react"
import { Button } from "../../tiptap-ui-primitive/button"
import { FileIcon } from "../../tiptap-icons/file-icon"
import { useTiptapEditor } from "../../hooks/use-tiptap-editor"
import { isExtensionAvailable } from "../../lib/tiptap-utils"

export interface FileUploadButtonProps {
  text?: string
}

export const FileUploadButton: React.FC<FileUploadButtonProps> = ({ text }) => {
  const editor = useTiptapEditor()

  const canInsert = React.useMemo(() => {
    if (!editor || !editor.isEditable) return false
    if (!isExtensionAvailable(editor, "fileUpload")) return false
    return editor.can().insertContent({ type: "fileUpload" })
  }, [editor])

  const handleClick = () => {
    if (!editor || !canInsert) return
    editor.chain().focus().setFileUploadNode().run()
  }

  return (
    <Button
      onClick={handleClick}
      data-disabled={!canInsert}
      disabled={!canInsert}
      aria-label="Добавить файл"
      title="Добавить файл"
    >
      <FileIcon className="tiptap-button-icon" />
      {text && <span>{text}</span>}
    </Button>
  )
}
